<template>
    <div class="orderDetailsPage">
        <headerNotice routerName="订单流水统计"></headerNotice>
        <!-- 搜索条 -->
        <div class="searchBox">
            <el-form
                :inline="true"
                :model="orderDetailSearchForm"
                class="demo-form-inline searchForm"
            >
                <el-form-item style="margin-right:40px;" label="支付起止日期">
                    <el-date-picker
                        @change="dateDataChange"
                        v-model="dateData"
                        value-format="yyyy-MM-dd"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        size="small"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item style="margin-right:40px;" label="订单号">
                    <el-input
                        v-model="orderDetailSearchForm.orderCode"
                        clearable
                        placeholder="请输入订单号"
                    ></el-input>
                </el-form-item>
                <el-form-item style="margin-right:40px;" label="客户">
                    <el-input
                        v-model="orderDetailSearchForm.customer"
                        clearable
                        placeholder="请输入客户名称"
                    ></el-input>
                </el-form-item>
                <!-- <el-form-item style="margin-right:40px;" label="业务员">
                    <el-input
                        v-model="orderDetailSearchForm.salesman"
                        clearable
                        placeholder="请输入业务员名称"
                    ></el-input>
                </el-form-item> -->

                <el-form-item style="margin-right:40px;" label="单据类型">
                    <el-select
                        v-model="orderDetailSearchForm.fundType"
                        clearable
                        placeholder="请选择单据类型"
                    >
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="余额充值" :value="1"></el-option>
                        <el-option label="销售订货" :value="2"></el-option>
                        <!-- <el-option label="业务提成" :value="5"></el-option> -->
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-right:40px;" label="单据类型">
                    <el-select
                        v-model="orderDetailSearchForm.payType"
                        clearable
                        placeholder="请选择支付方式"
                    >
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="微信" :value="1"></el-option>
                        <el-option label="余额" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSearch">查询</el-button>
                    <el-button type="danger" @click="clearSearch">清空</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 搜索结果列表 -->
        <div class="searchList">
            <div class="searchListContent">
                <el-table
                    ref="searchListTable"
                    :data="orderDetailTableData"
                    style="width: 100%"
                    show-summary
                    :summary-method="getSummaries"
                    border
                    :v-loading="loading"
                >
                    <el-table-column align="center" type="index" prop="no" label="序号" width="50"></el-table-column>
                    <el-table-column align="center" width="180" prop="orderCode" label="关联单号"></el-table-column>
                    <el-table-column align="center" width="180" prop="createTime" label="下单时间"></el-table-column>
                    <el-table-column align="center" prop="customer" label="客户名"></el-table-column>
                    <!-- <el-table-column align="center" prop="salesman" label="业务员名称"></el-table-column> -->
                    <el-table-column align="center" prop="fundType" label="单据类型"></el-table-column>
                    <el-table-column align="center" prop="amount" label="单据金额(￥)"></el-table-column>
                    <el-table-column align="center" prop="abate" label="折扣(￥)"></el-table-column>
                    <el-table-column align="center" prop="disAmount" label="实付金额(￥)"></el-table-column>
                    <el-table-column align="center" prop="couponAmount" label="用券抵扣金额(￥)"></el-table-column>
                    <el-table-column align="center" label="支付方式">
                        <template slot-scope="scope">
                            <span v-if="scope.row.payType==1">微信</span>
                            <span v-if="scope.row.payType==2">余额</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--搜索列表分页-->
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[25, 50, 75, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: true,
            totalCount: 0,//总数据条数
            maxResultCount: 25, //默认一页显示的个数,
            currentPage: 1,
            baseUrl: this.$store.state.apiUrl,
            dateData: [],//日期
            orderDetailSearchForm: {//搜索表单
                StartTime: '',
                EndTime: '',
                orderCode: '',
                customer: '',
                salesman: '',
                fundType: 0,
                payType: 0,
            },
            orderDetailTableData: [],//表单数据
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
        });
    },
    methods: {
        //合计统计赛选
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (index === 1 || index === 2|| index === 3|| index === 4) {
                    sums[index] = 'N/A';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] = sums[index].toFixed(2) + ' 元';
                } else {
                    sums[index] = 'N/A';
                }
            })
            return sums
        },
        dateDataChange(val) {
            if (!val) {
                this.dateData = []
            }
        },
        //获取列表数据
        getDatas(params) {
            let self = this;
            if (this.dateData.length) {
                params.StartTime = this.dateData[0];
                params.EndTime = this.dateData[1];
            }
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminStatistics/GetStatisticsByOrderFlow",
                params: params,
                success(res) {
                    self.orderDetailTableData = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    console.log(res);
                    self.loading = false;
                }
            })
        },
        //清空搜索
        clearSearch() {
            this.orderDetailSearchForm = {//搜索表单
                StartTime: '',
                EndTime: '',
                orderCode: '',
                customer: '',
                salesman: '',
                fundType: 0,
                payType: 0,
            }
        },
        //搜索
        onSearch(params) {
            let self = this;
            let form = this.orderDetailSearchForm;
            form.MaxResultCount = this.maxResultCount;
            form.SkipCount = 0;
            this.currentPage = 1;
            this.getDatas(form);
        },
        //搜索列表一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
            };
            this.getDatas(params);
        },
        //搜索列表跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.orderDetailSearchForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            this.getDatas(params);
        },
    }
}
</script>

<style lang='scss' scoped>
.orderDetailsPage {
    //搜索框
    .searchBox {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchForm {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding: 20px;
            padding-bottom: 0;
            .el-form-item {
                margin-bottom: 20px;
            }
        }
    }
    //搜索列表
    .searchList {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchListHead {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            padding-left: 20px;
            background: #efefef;
            border-bottom: 1px solid #c5c5c5;

            .searchListCtl {
                button,
                .el-select {
                    width: 130px;
                    margin-left: 10px;
                }
            }
        }
        .searchListContent {
            .moneyColor {
                color: #3498db;
                // cursor: pointer;
            }
        }
    }
}
</style>
